import {ChangeDetectionStrategy, Component, computed, inject, linkedSignal} from '@angular/core';
import {toSignal} from '@angular/core/rxjs-interop';
import {FormsModule} from '@angular/forms';
import {ErrorService} from '@dv/kitadmin/core/errors';
import {
    Click2EditComponent,
    Click2EditDirective,
    DatepickerTextfieldComponent,
    EditModeDirective,
} from '@dv/shared/angular';
import {KibonExchangeConfigApi} from '@dv/shared/backend/api/kibon-exchange-config.api';
import {TranslocoModule} from '@jsverse/transloco';
import moment from 'moment';
import type {BsDatepickerConfig} from 'ngx-bootstrap/datepicker';
import {TooltipModule} from 'ngx-bootstrap/tooltip';

@Component({
    selector: 'dv-kibon-configuration',
    imports: [
        Click2EditComponent,
        EditModeDirective,
        Click2EditDirective,
        FormsModule,
        TranslocoModule,
        TooltipModule,
        DatepickerTextfieldComponent,
    ],
    templateUrl: './kibon-configuration.component.html',
    styles: `
        :host {
            display: block;
        }
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class KibonConfigurationComponent {
    private errorService = inject(ErrorService);
    private configApi = inject(KibonExchangeConfigApi);

    public periodPickerConfig: Partial<BsDatepickerConfig> = {
        minMode: 'year',
        dateInputFormat: 'YYYY',
    };

    private config = toSignal(this.configApi.get$());

    public eingewoehnungPositionSinceYear = linkedSignal(() => {
        const year = this.config()?.kiBonEingewoehnungPositionSinceYear;

        return year ? moment().year(year).startOf('year') : undefined;
    });
    public eingewoehnungPositionSincePeriod = computed(() => {
        const currentYear = this.eingewoehnungPositionSinceYear();

        return currentYear ?
            `${currentYear.format('YY')}/${moment(currentYear).add(1, 'year').format('YY')}` :
            '';
    });

    public submitForm(): void {
        this.errorService.clearAll();

        const backendRequestParams = {
            jaxKibonExchangeConfig: {
                kiBonEingewoehnungPositionSinceYear:
                    this.eingewoehnungPositionSinceYear()?.year() ?? undefined,
            },
        };

        this.configApi.update$(backendRequestParams).subscribe();
    }
}

